import * as React from "react";

import StandardizedTestComponent from "../components/use_case/StandardizedTest";
import Layout from "../components/layout/layout";
import Seo from "../components/seo";
import { useTranslation } from 'react-i18next';

const StandardizedTest = () => {
  const {t} = useTranslation();
  return (
    <>
      <Seo
        title={t('admission_test')}
        description="Des solutions adaptées pour conduire vos tests standardisés à grande échelle."
      />
      <Layout>
        <StandardizedTestComponent />
      </Layout>
    </>
  );
};

export default StandardizedTest;
